import React, { useEffect, useState, useRef } from "react";
import api from "../../api/axios";
import QRCode from "react-qr-code";


const PrintTagModal = ({ show, onClose, recordId }) => {
  const [data, setData] = useState(null);
  const printRef = useRef();

  useEffect(() => {
    if (show && recordId) {
      api.get(`companyblog/admin/print-tag/${recordId}/`).then((res) => {
        setData(res.data);
      });
    }
  }, [show, recordId]);

const handlePrint = () => {
  const printContent = printRef.current.outerHTML;
  const win = window.open("", "", "width=400,height=300");

  win.document.write(`
    <html>
      <head>
        <title>Print Tag</title>
        <style>
          @page {
            size: 370px 180px;
            margin: 0;
          }

          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
          }

          .print-root {
            width: 370px;
            height: 180px;
            box-sizing: border-box;
            padding: 4px;
          }

          h4 {
            margin: 0 0 2px 0;
            font-size: 13px;
          }

          p {
            margin: 1px 0;
            font-size: 10px;
          }

          hr {
            margin: 3px 0;
          }
        </style>
      </head>
      <body>
        <div class="print-root">
          ${printContent}
        </div>
      </body>
    </html>
  `);

  win.document.close();
  win.focus();
  win.print();
  win.close();
};


  if (!show || !data) return null;

  return (
    <div className="modal-backdrop show">
      <div className="modal d-block">
        <div className="modal-dialog modal-md" style={{height: "600px", width: "700px"}}>
          <div className="modal-content" style={{backgroundColor: "#ffffff", opacity: 1}}>
            <div className="modal-header">
              <h5 style={{fontWeight: "600"}}>Print Tag</h5>
              <button className="btn-close" onClick={onClose}></button>
            </div>

            <div className="modal-body" ref={printRef} style={{ width: "370px", height: "180px", fontSize: "9px", lineHeight: "1.2", padding: "0 2px",
            boxSizing: "border-box", }}>
                  <h4 style={{ color: "dodgerblue", margin: "0 0 2px 0", fontSize: "13px" }}>
                    Z1 Technology and Trade
                  </h4>
                  <p style={{ margin: "0" }}>Bhairahawa, Rupandehi</p>
                  <hr style={{ margin: "4px 0" }} />

                  {/* GRID START */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr auto",
                      columnGap: "4px",
                      alignItems: "start",
                    }}
                  >
                    {/* LEFT COLUMN – ALL TEXT */}
                    <div>
                      <p style={{ color: "red", margin: "1px 0" }}>
                        <strong>Track:</strong> {data.track_id}
                      </p>
                      <p style={{ margin: "1px 0" }}>
                        <strong>Name:</strong> {data.customer_name}
                      </p>
                      <p style={{ margin: "1px 0" }}>
                        <strong>Contact:</strong> {data.customer_contact}
                      </p>
                      <p style={{ margin: "1px 0" }}>
                        <strong>Equipment:</strong> {data.equipment_name}
                      </p>
                      <p style={{ margin: "1px 0" }}>
                        <strong>Amount:</strong> {data.amount}
                      </p>
                      <p style={{ margin: "1px 0", wordBreak: "break-word" }}>
                        <strong>Problem:</strong> {data.problems}
                      </p>
                    </div>

                    {/* RIGHT COLUMN – QR ONLY */}
                    <div style={{ textAlign: "center" }}>
                      <QRCode  value={`${window.location.origin}/track-service?track_id=${data.track_id}`} size={45} />
                    </div>
                  </div>
                  {/* GRID END */}
                </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
              <button className="btn btn-success" onClick={handlePrint}>
                Print
              </button>
            </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintTagModal;